import { ApiClientError } from './apiClient';

export const SCREEN_LIMIT_CODE = 'SCREEN_LIMIT_REACHED';

/** For raw playback-start fetches (.m3u8 probe / sports-vod preflight). */
export function isScreenLimitBody(status: number, bodyText: string | null | undefined): boolean {
  if (status !== 403 || !bodyText) return false;
  try {
    const parsed = JSON.parse(bodyText) as { error?: { code?: string } };
    return parsed?.error?.code === SCREEN_LIMIT_CODE;
  } catch {
    return false;
  }
}

/** For api()-routed calls (sports dash-init). */
export function isScreenLimitApiError(err: unknown): boolean {
  return err instanceof ApiClientError && err.code === SCREEN_LIMIT_CODE;
}
